// extracted by mini-css-extract-plugin
module.exports = {"termsHeading":"terms_termsHeading__3Oh4v","subHeading":"terms_subHeading__3JYtL"};